import React, { createContext, useContext, useState, useEffect } from 'react'

const AuthContext = createContext(null)

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [userDataList, setUserDataList] = useState(null)
  const [tenantData, setTenantData] = useState(null)
  const [isLoading, setIsLoading] = useState(true) // ✅ Add loading state

  // Load user from localStorage on mount
  useEffect(() => {
    const storedUser = localStorage.getItem('authUser')
    const storedTenantData = localStorage.getItem('tenantData')
    const storedUserDataList = localStorage.getItem('userDataList')

    if (storedUser) {
      setUser(JSON.parse(storedUser))
    }
    if (storedTenantData) {
      setTenantData(JSON.parse(storedTenantData))
    }
    if (storedUserDataList) {
      setUserDataList(JSON.parse(storedUserDataList))
    }
    
    setIsLoading(false) // ✅ Set loading to false after checking localStorage
  }, [])

  const login = (userData, tenantInfo = null, userDataList) => {
    setUser(userData)
    setUserDataList(userDataList)
    if (tenantInfo) {
      setTenantData(tenantInfo)
      localStorage.setItem('tenantData', JSON.stringify(tenantInfo))
    }
    localStorage.setItem('authUser', JSON.stringify(userData))
  }

  const updateTenantProfile = (updatedData) => {
    setTenantData(prev => ({ ...prev, ...updatedData }))
    localStorage.setItem('tenantData', JSON.stringify({ ...tenantData, ...updatedData }))
    
    // Also update user name if changed
    if (updatedData.TenantName) {
      const updatedUser = { ...user, name: updatedData.TenantName }
      setUser(updatedUser)
      localStorage.setItem('authUser', JSON.stringify(updatedUser))
    }
  }

  const logout = () => {
    setUser(null)
    setTenantData(null)
    setIsLoading(false) // Reset loading state
    localStorage.removeItem('authUser')
    localStorage.removeItem('tenantData')
    localStorage.removeItem('loginResponse')
    localStorage.removeItem('userDataList')
    localStorage.removeItem('userId')
    localStorage.removeItem('userRole')
    localStorage.removeItem('username')
    localStorage.removeItem('password')
  }

  return (
    <AuthContext.Provider value={{ 
      user, 
      isLoading, // ✅ Add isLoading to context
      userDataList,
      tenantData,
      login, 
      logout, 
      updateTenantProfile,
      isLoggedIn: !!user 
    }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used inside <AuthProvider>')
  return ctx
}